import { DynamicForm, FormConfig } from "@components/DynamicForm/DynamicForm";
import { useNotification } from "@hooks/useNotification";
import { useQuery } from "@hooks/useQuery";
import { toInteger } from "lodash";
import { useEffect, useState } from "react";
import { FieldValues } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { ContentWrapper } from "~/Components";
import { useAuth } from "~/Hooks/useAuth";
import { useDocumentDetails } from "~/Modules/ECMS/MAGP/ApprovalManagement/Drilldown.Hooks";
import { eramanCMSApi, post, put } from "~/Services";
import { eramanHost } from "~/Utils";
import { decodeHTML } from "~/Utils/CommonUtils";
import { fields } from "../constants";
import { useCategoryDocumentDetails } from "./hooks/Category.hook";

export const AddEditFAndBAddEditCategory = () => {
  const query = useQuery();
  const navigate = useNavigate();
  const { openToast } = useNotification();
  const { user } = useAuth();
  const [formConfig, setFormConfig] = useState<FormConfig | null>(null);
  const [records, setRecords] = useState<any[]>([]);
  const {
    data: editOutlet,
    isLoading: drilldownLoading,
    refetch: refetchBrands,
  } = useCategoryDocumentDetails(query.get("editId") || "");

  const {
    data: editOutletById,
    isLoading: isLoadingBrands,
    refetch: refetchDocument,
  } = useDocumentDetails(query?.get("id") || "");

  useEffect(() => {
    if (query.get("id")) {
      refetchDocument();
    }
    if (query.get("editId")) {
      refetchBrands();
    }
  }, [query.get("editId"), query.get("id")]);

  const getRecords = () => {
    let url = `/api/food-beverage-types/all-fields`;
    eramanCMSApi
      .get(url)
      .then((res: any) => {
        if (res && res.data) {
          let envelopes = res.data;
          setRecords(envelopes);
        }
      })
      .catch(() => {
        setRecords([]);
      });
  };

  useEffect(() => {
    getRecords();
  }, []);

  const Config: FormConfig = {
    initialValues: {
      name: decodeHTML(editOutletById?.payload?.name) ?? decodeHTML(editOutlet?.name) ?? "",
      field_food_malay_title:
        decodeHTML(editOutletById?.payload?.field_food_malay_title) ??
        decodeHTML(editOutlet?.field_food_malay_title) ??
        "",
      field_food_mandrian_title:
        decodeHTML(editOutletById?.payload?.field_food_mandrian_title) ??
        decodeHTML(editOutlet?.field_food_mandrian_title) ??
        "",
      field_sequence_number: editOutletById?.payload?.field_sequence_number ?? editOutlet?.field_sequence_number,
      published: editOutletById?.payload?.published
        ? decodeHTML(editOutletById?.payload?.published)
        : decodeHTML(editOutlet?.published),
    },
    fields: fields.fAndBCategory.map((field: any) => {
      if (field.name === "field_sequence_number") {
        return {
          ...field,
          validation: {
            required: `${field.label || field.name} is required`,
            validate: (value: string, formValues: FieldValues) => {
              if (!value) return true;
              const existingRecord = records.find((record: any) => {
                return (
                  toInteger(record[field.name]) === toInteger(value) &&
                  record.id !== (editOutlet?.id || editOutletById?.payload?.id)
                );
              });
              return !existingRecord || `${field.label || field.name} already exists`;
            },
          },
        };
      }
      // if (field.name === "name") {
      //   return {
      //     ...field,
      //     validation: {
      //       required: `${field.label || field.name} is required`,
      //       validate: (value: string, formValues: FieldValues) => {
      //         if (!value) return true; // Skip uniqueness check if empty (required handles it)
      //         const existingRecord = records.find(
      //           (record: any) => {
      //             return (decodeHTML(record[field.name]) === decodeHTML(value) &&
      //             record.id !== (editOutlet?.id || editOutletById?.payload?.id))
      //       });
      //         return (
      //           !existingRecord ||
      //           `${field.label || field.name} already exists`
      //         );
      //       },
      //     },
      //   };
      // }
      // if (["field_food_malay_title", "field_food_mandrian_title"].includes(field.name)) {
      //   return {
      //     ...field,
      //     validation: {
      //       validate: (value: string, formValues: FieldValues) => {
      //         if (!value) return true; // Skip uniqueness check if empty
      //         const existingRecord = records.find(
      //           (record: any) =>
      //             decodeHTML(record[field.name]) === decodeHTML(value) &&
      //             record.id !== (editOutlet?.id || editOutletById?.payload?.id)
      //         );
      //         return (
      //           !existingRecord ||
      //           `${field.label || field.name} already exists`
      //         );
      //       },
      //     },
      //   };
      // }
      return field;
    }),
  };

  const onSubmit = async (
    data: FieldValues,
    apiUrl: string,
    action: string,
    method: string,
    status: "DRAFT" | "PENDING",
    reviewNotes?: string
  ) => {
    let imageKeys: any = ["field_common_image"];
    for (const key of imageKeys) {
      const field = data[key];

      try {
        if (field?.[0]?.originFileObj) {
          const formData = new FormData();
          formData.append("upload-file", field[0].originFileObj);
          formData.append("application", "ERAMAN");
          const res: any = await post("management/upload-file", formData);
          if (res) data[key] = res.response.data;
        } else if (field?.[0]?.url) {
          data[key] = field[0].url;
        } else if (Array.isArray(field) && field.length === 0) {
          data[key] = "";
        } else if (!field) {
          data[key] = "";
        }
      } catch (error) {
        console.error(`Error handling image field ${key}:`, error);
      }
    }

    const payload = {
      action: action,
      method: method,
      module: "Product Management",
      subModule: "fAndBCategory",
      type: "DEDICATED",
      application: "ERAMAN",
      reviewNotes: reviewNotes,
      appList: [
        {
          appName: "ERAMAN",
          apiUrl: apiUrl,
        },
      ],
      payload: {
        ...(action === "UPDATE" ? { id: editOutletById?.payload?.id || editOutlet?.id } : {}),
        ...data,
      },
      status: status,
    };

    // Log the complete payload
    console.log("Final Payload:", payload);

    // Commented out API calls for testing
    if (query.get("id")) {
      put(`/management/update-document?approvalId=${query.get("id")}`, payload)
        .then((response: any) => {
          openToast({
            content: status == "PENDING" ? "Data Sent for Review" : "Data Saved Successfully",
            type: "success",
          });
          if (response.status === "OK" && status == "PENDING") {
            navigate("/dedicated/status-information?activeTab=pending");
          } else {
            navigate("/dedicated/status-information?activeTab=draft");
          }
        })
        .catch((err: any) => {
          openToast({
            content: "Failed to save data",
            type: "error",
          });
        });
    } else {
      post(`/management/publish`, payload)
        .then((response: any) => {
          openToast({
            content: status == "DRAFT" ? "Data saved successfully" : "Data Sent for Review",
            type: "success",
          });
          if (response.status === "OK" && status == "PENDING") {
            navigate("/dedicated/status-information?activeTab=pending");
          } else {
            navigate("/dedicated/status-information?activeTab=draft");
          }
        })
        .catch((err: any) => {
          openToast({
            content: "Failed to save data",
            type: "error",
          });
        });
    }
  };

  return (
    <ContentWrapper
      title={`${query.get("id") || query.get("editId") ? "Edit" : "Add New"} Category`}
      showBack
    >
      <DynamicForm
        isLoading={drilldownLoading}
        config={Config}
        onSubmit={(data, buttonValue, reviewNotes) =>
          onSubmit(
            data,
            `${query.get("editId") || query.get("type") === "update" ? `${eramanHost}/api/food-and-beverages-types-taxonomy-items-data-list/${editOutletById?.payload?.id || editOutlet?.id}` : `${eramanHost}/api/create/food-and-beverages-types-taxonomy-items-data-list`}`,
            `${query.get("editId") || query.get("type") === "update" ? "UPDATE" : "CREATE"}`,
            `${query.get("editId") || query.get("type") === "update" ? "PATCH" : "POST"}`,
            buttonValue == "save" ? "DRAFT" : "PENDING",
            reviewNotes
          )
        }
      />
    </ContentWrapper>
  );
};
